exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".riesgoalto[data-v-8b8cf7fa]{background-color:#ce6757!important;color:#fff}.aspectodestacado[data-v-8b8cf7fa]{background-color:#15b7b9!important;color:#fff}.prioridadmedia[data-v-8b8cf7fa]{background-color:#ffd36e!important;color:#4a4a4a}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8b8cf7fa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/frs/Priorizationfrs.vue
// module id = 806
// module chunks = 2